
import {React, useState, useContext, useEffect, useRef} from "react"
import {useStyle} from '../../context/styleContext/styleContext'
import ReactGA from 'react-ga4';
import { Paper } from '@mui/material';
import { Container, Typography, Divider, Box, List, ListItem, ListItemText } from "@mui/material";


export default function Learning(){

  const { style, setStyle } = useStyle();
  const [width, setWidth] = useState(window.innerWidth)

function handleWindowSizeChange() {
    setWidth(window.innerWidth);
}
useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
}, []);

const isMobile = width <= 768;

useEffect(() => {
  document.title = 'Parish Audio | Cutting-Edge Audio Processing | Learning Center';
}, []);

ReactGA.send({
    hitType:"pageview",
    page:"learning/delay",
    title:"learning/delay",
  })

  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);




    return(
        <>
        <div style={{display:'flex', backgroundImage: `url("/RecordingStudioStockImage1.jpg")`, backgroundSize: "cover", backgroundPosition: "center", marginBottom:'0px', flex:1, minHeight:height-130, color:style.color4, padding:'0px'}}>
        <div style={{display:'flex', flex:1}}>

        <div className="dark-alpha-80" style={{flex:1}}>
<div style={{width:'95%', maxWidth:'1000px', margin:'auto'}}>



        <h1 ref={topContainer} style={{marginTop:'20px'}}>Learning Center</h1>

        <Divider className="mobile-card-divider" />
        <div style={{minHeight:height - 400}}>
        <h2 style={{marginBottom:'20px'}}>Categories</h2>
        <ul style={{}}>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/chorus'>Chorus</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/compression'>Compression</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/delay'>Delay</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/distortion'>Distortion</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/equalization'>Equalization (EQ)</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/overdrive'>Overdrive</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/reverb'>Reverb</a>
            </li>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/reverb'>Reverb</a>
            </li>
        </ul>
        </div>

<h2>Topics:</h2>


<ul style={{}}>
            <li style={{marginBottom:'10px'}}>
                <a href='/learning/compare-distortion-overdrive-fuzz'>Overdrive vs Distortion vs Fuzz: What’s the Difference?</a>
            </li>
            </ul>

        <Divider className="mobile-card-divider" />
        <div style={{textAlign:"center"}}>
        <a href="/home" style={{margin:'10px'}} >Home </a> 
        <a href="/" style={{margin:'10px'}} >Plugins</a>
        </div>

  </div>
  <div>

  
      </div>
     

      </div>

      </div>
</div>




        
        </>

    )
}